import React, {useEffect} from 'react';
import classNames from "classnames";
import Input from "src/components/common/input/Input";
import {useTranslationService} from "src/services/TranslationService";
import {isString} from "../../utils/common";
import ErrorForm from "../common/input/ErrorForm";

export const CommercialInfoCheckbox = ({
    onClick,
    className,
    regulatedCompany,
    input,
    checked,
    success,
    error,
    errorMsg
}) => {
    const {t} = useTranslationService();

    return <>
        <div className={classNames('d-flex',className)}>
            <span className={'flex-shrink-0'}>
                <Input
                    type={'checkbox'}
                    onChange={onClick}
                    ref={input}
                    name="commercialCommunicationsAccepted"
                    checked={checked}
                    success={success}
                    error={error}
                />
            </span>
            { regulatedCompany && <span className={'dx-ml-3'}>
                {t(`new-login.allow-for-commercial-communications-${regulatedCompany}`)}
            </span> }
        </div>
        {isString(errorMsg) &&
            <p className={classNames("dx-mb-7 text-danger-dark")}>
                <ErrorForm error={errorMsg} isKey/>
            </p>}
    </>
}
